export type CustomProps = Record<string, unknown>;

export type CustomAttribute = {
    name: string;
    value: string;
};

export enum RouteType {
    Route = 'route',
    Application = 'application',
    Div = 'div',
}

export type Route = {
    type: RouteType;
    routes?: Route[];
    path?: string;
    name?: string;
    props?: CustomProps;
    attrs?: CustomAttribute[];
};

export type Layout = {
    routes: Route[];
    containerEl: string;
};
